import request from '@/router/axios'

const API = '/api/produce/wagon-tippler-efficiency-daily'

function unwrap(res) {
  const body = res && res.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
  return body || {}
}

function pickNumber(source, keys, fallback) {
  for (let i = 0; i < keys.length; i += 1) {
    const value = source && source[keys[i]]
    if (value !== null && value !== undefined && value !== '') return Number(value) || 0
  }
  return fallback
}

function normalizeSummary(raw = {}) {
  return {
    statDate: raw.statDate || raw.statisticsDate || raw.operationDate || '',
    deviceCode: raw.deviceCode || raw.deviceName || '',
    operationCount: pickNumber(raw, ['operationCount', 'totalOperationCount', 'totalCount'], 0),
    vehicleCount: pickNumber(raw, ['vehicleCount', 'totalVehicleCount', 'completedVehicleCount'], 0),
    totalOperationSeconds: pickNumber(raw, ['totalOperationSeconds', 'totalSeconds', 'operationSeconds'], 0),
    plannedSeconds: pickNumber(raw, ['plannedSeconds', 'planOperationSeconds', 'plannedOperationSeconds'], 0),
    avgOperationSeconds: pickNumber(raw, ['avgOperationSeconds', 'averageOperationSeconds'], 0),
    utilizationRate: pickNumber(raw, ['utilizationRate', 'equipmentUtilizationRate'], 0)
  }
}

function normalizeTrendPoint(raw = {}) {
  return {
    statDate: raw.statDate || raw.statisticsDate || raw.operationDate || '',
    operationCount: pickNumber(raw, ['operationCount', 'totalOperationCount', 'totalCount'], 0),
    totalOperationSeconds: pickNumber(raw, ['totalOperationSeconds', 'totalSeconds', 'operationSeconds'], 0),
    avgOperationSeconds: pickNumber(raw, ['avgOperationSeconds', 'averageOperationSeconds'], 0),
    utilizationRate: pickNumber(raw, ['utilizationRate', 'equipmentUtilizationRate'], 0)
  }
}

function normalizeDashboard(raw = {}) {
  const summary = normalizeSummary(raw.summary || raw.dailySummary || raw)
  const weekCompare = raw.weekCompare || raw.weekComparison || {}
  const report = raw.report || raw.trendReport || {}
  const trend = Array.isArray(raw.trend) ? raw.trend : (Array.isArray(raw.trendList) ? raw.trendList : [])

  return {
    summary,
    weekCompare: {
      currentWeekStart: weekCompare.currentWeekStart || '',
      currentWeekEnd: weekCompare.currentWeekEnd || '',
      lastWeekStart: weekCompare.lastWeekStart || '',
      lastWeekEnd: weekCompare.lastWeekEnd || '',
      currentUtilizationRate: pickNumber(weekCompare, ['currentUtilizationRate', 'currentRate'], 0),
      lastUtilizationRate: pickNumber(weekCompare, ['lastUtilizationRate', 'lastRate'], 0),
      changeValue: pickNumber(weekCompare, ['changeValue', 'changePctValue'], 0),
      changePercent: pickNumber(weekCompare, ['changePercent', 'changeRate'], 0),
      direction: weekCompare.direction || 'flat'
    },
    trend: trend.map(normalizeTrendPoint),
    report: {
      title: report.title || '翻车机效率趋势报告',
      summaryText: report.summaryText || report.summary || '',
      riskText: report.riskText || report.risk || '',
      suggestionText: report.suggestionText || report.suggestion || ''
    },
    sourceStatus: raw.sourceStatus || {}
  }
}

export function fetchEfficiencyDashboard(data) {
  return request({
    url: `${API}/dashboard`,
    method: 'post',
    data
  }).then(unwrap).then(normalizeDashboard)
}
